/**
 * InfoBadge — small "(i)" pill with a tooltip/inline popover.
 * Used across the Trusted Institutions surface to explain terminology
 * (Trusted, Participating, Validate FSP, Regulatory validation, etc.).
 */
import { useState } from "react";
import { Info, X } from "lucide-react";
import { NAVY, GOLD } from "@/components/wallet/WalletShell";

export default function InfoBadge({ title, body, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex align-middle">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-label={title}
        data-testid={testid || "info-badge"}
        className="w-5 h-5 rounded-full flex items-center justify-center hover:bg-slate-100 transition"
        style={{ color: "#94A3B8" }}
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          className="absolute z-30 left-6 top-0 w-72 rounded-xl bg-white border border-slate-200 shadow-lg p-3 text-left"
          data-testid={`${testid || "info-badge"}-popover`}
        >
          <span className="flex items-start justify-between gap-2">
            <span className="text-[10.5px] uppercase tracking-widest font-semibold" style={{ color: GOLD }}>{title}</span>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700" aria-label="Close">
              <X className="w-3.5 h-3.5" />
            </button>
          </span>
          <span className="block text-[11.5px] text-slate-600 leading-relaxed mt-1">{body}</span>
        </span>
      )}
    </span>
  );
}
